import { faLoader } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { Box, Tab } from "@mui/material"
import { AppContext } from "components/AppContextProvider"
import theme from "css/theme/light"
import { allRoutes } from "generated/routes"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, NavLink, useLocation } from "react-router-dom"
import CrisisButton from "components/navigation/CrisisButton"
import MenuIcon from "../MenuIcon"
import {
  StyledDiv,
  StyledHeaderLogo,
  StyledMenuDrawer,
  StyledMenuTabs,
  StyledToggleDrawerIconButton,
  StyledTypography
} from "./SideDrawer.styled"

const SideDrawer = (props) => {
  const { matches } = props
  const { t, i18n } = useTranslation()
  const appContext = useContext(AppContext)
  const location = useLocation()
  const [selectedPath, setPath] = useState("/")
  const [menuTitles, setMenuTitles] = useState([])

  useEffect(() => {
    if (i18n.isInitialized) {
      const titles = t("app.menu.titles", { returnObjects: true })
      setMenuTitles(Array.isArray(titles) ? titles : [])
    }
  }, [i18n.isInitialized, i18n.language])

  useEffect(() => {
    setPath(location.pathname)
  }, [location.pathname, appContext.appUser.app.normalPages])

  const handleChange = (_event, newValue) => {
    setPath(newValue)
    if (!matches) {
      appContext.toggleMainNav(false)
    }
  }

  const getStartingPath = (path, subRouteCount = 0) => {
    const match = path.match(/^\/([^\/]+)(\/[^\/]+)?/)
    if (!match) return null
    if (subRouteCount === 0) return match[1]
    return match
      .slice(1, subRouteCount + 2)
      .filter(Boolean)
      .join("/")
  }

  const drawerChildren = (
    <>
      <Link to={allRoutes.Dashboard()}>
        <StyledHeaderLogo openDrawer={appContext.isMainNavOpen}></StyledHeaderLogo>
      </Link>
      <StyledMenuTabs
        orientation="vertical"
        variant="scrollable"
        value={selectedPath}
        openDrawer={appContext.isMainNavOpen}
        onChange={handleChange}
        aria-label="Main menu"
        indicatorColor="primary">
        {appContext.appUser.app.normalPages
          .filter((x) => !x.unauthenticatedTemplate)
          .map((item) => {
            const translatedTitles = menuTitles?.find((title) => title.menuId === item.menuId)
            const isCurrentRoute =
              getStartingPath(item.route.path) === getStartingPath(selectedPath)
                ? selectedPath
                : item.route.path
            return (
              <Tab
                icon={<MenuIcon name={item.icon} />}
                key={item.title}
                component={NavLink}
                to={item.route.path}
                label={
                  !appContext.isMainNavOpen ? "" : !translatedTitles ? item.title : translatedTitles.title
                }
                value={isCurrentRoute}
              />
            )
          })}
        {appContext.loadingAppstructure && (
          <Tab icon={<FontAwesomeIcon spin icon={faLoader} />} label={t("global.loading", "Loading..")} />
        )}

        {appContext.isMainNavOpen && appContext.appUser.app.sysadmPages?.length > 0 && (
          <StyledTypography variant="caption">
            {t("settings.form.systemadmin", "System admin")}
          </StyledTypography>
        )}
        {appContext.appUser.app.sysadmPages.map((item) => {
          const translatedTitles = menuTitles.find((title) => title.menuId === item.menuId)
          const isCurrentRoute =
            getStartingPath(item.route.path, true) === getStartingPath(selectedPath, true)
              ? selectedPath
              : item.route.path
          return (
            <Tab
              icon={<MenuIcon name={item.icon} />}
              key={item.title}
              component={NavLink}
              to={item.route.path}
              label={!appContext.isMainNavOpen ? "" : !translatedTitles ? item.title : translatedTitles.title}
              value={isCurrentRoute}
            />
          )
        })}
      </StyledMenuTabs>
      <Box>
        <Box justifyContent="flex-end" display="flex" flexDirection="row">
          {appContext.isMainNavOpen && (
            <Box
              onClick={() => appContext.toggleMainNav()}
              width="100%"
              textAlign="center"
              sx={{ display: { md: "none" } }}>
              <CrisisButton fontSize="12px" padding="0px 12px" margin="2px 0 0 0" height="40px" />
            </Box>
          )}
          <StyledToggleDrawerIconButton
            variant="tonal"
            color="secondary"
            onClick={() => appContext.toggleMainNav()}
            size="large">
            {!appContext.isMainNavOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </StyledToggleDrawerIconButton>
        </Box>
        <StyledDiv openDrawer={appContext.isMainNavOpen}>
          <img
            src={appContext.appUser.app.logoUrl ? appContext.appUser.app.logoUrl : theme.logo.src}
            alt={theme.logo.alt}
          />
        </StyledDiv>
      </Box>
    </>
  )
  return (
    <nav>
      <StyledMenuDrawer
        variant={matches ? "permanent" : "temporary"}
        open={appContext.isMainNavOpen}
        onClose={appContext.toggleMainNav}
        openDrawer={appContext.isMainNavOpen}
        ModalProps={{
          keepMounted: true
        }}>
        {drawerChildren}
      </StyledMenuDrawer>
    </nav>
  )
}

export default SideDrawer
